export const initAccount = () => {
  const accountBlocks: NodeListOf<HTMLDivElement> = document.querySelectorAll(".account-block");

  accountBlocks.forEach((accountBlock) => {
    const toggle = accountBlock.querySelector(".toggle") as HTMLDivElement;
    const content = accountBlock.querySelector(".content") as HTMLDivElement;
    const editor = accountBlock.querySelector(".editor") as HTMLDivElement;

    if (toggle) {
      toggle.addEventListener("click", () => {
        content.classList.toggle("active");
        editor.classList.toggle("active");
      });
    }
  });
};
